import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const ArrayValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value.length === 0
      ? { array: { value: control.value } }
      : null;
  };
};
